const MissingData = () => {
    return <div>Błąd danych, lub token wygasł</div>;
};

export default MissingData;
